import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as r } from "../../core/accessorSupport/decorators/subclass.js";
import t from "../Widget.js";
import o from "./SearchViewModel.js";
import { accessibleHandler as l } from "../support/decorators/accessibleHandler.js";
import { messageBundle as i } from "../support/decorators/messageBundle.js";
import "../../core/Logger.js";
import { tsx as u } from "../support/jsxFactory.js";
import "../support/widgetUtils.js";
var n = {
  base: "esri-search-result-renderer esri-widget",
  anchor: "esri-widget__anchor",
  showMoreResults: "esri-search-result-renderer__more-results--show-more-results",
  moreResults: "esri-search-result-renderer__more-results",
  moreResultsList: "esri-search-result-renderer__more-results-list",
  moreResultsHeader: "esri-search-result-renderer__more-results-header",
  moreResultsItem: "esri-search-result-renderer__more-results-item",
  moreResultsListHeader: "esri-search-result-renderer__more-results-list-header"
};

var c = /*#__PURE__*/function (_t) {
  _inherits(c, _t);

  var _super = _createSuper(c);

  function c(e, s) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, e, s), _this.messages = null, _this.showMoreResultsOpen = !1, _this.viewModel = null;
    return _this;
  }

  _createClass(c, [{
    key: "render",
    value: function render() {
      var e = _defineProperty({}, n.showMoreResults, this.showMoreResultsOpen);

      return u("div", {
        class: n.base
      }, u("div", {
        key: "esri-search-renderer__container",
        class: this.classes(n.moreResults, e)
      }, this.renderSearchResultName(), this.renderMoreResults()));
    }
  }, {
    key: "renderMoreResults",
    value: function renderMoreResults() {
      return u("div", {
        key: "esri-search-renderer__more-results"
      }, this.renderMoreResultsButton(), this.renderMoreResultsLists());
    }
  }, {
    key: "renderSearchResultName",
    value: function renderSearchResultName() {
      var e;
      var s = null == (e = this.viewModel) ? void 0 : e.selectedResult,
          r = s && s.name || "";
      return u("div", {
        key: "esri-search-renderer__result-name",
        class: n.moreResultsItem
      }, r);
    }
  }, {
    key: "renderMoreResultsLists",
    value: function renderMoreResultsLists() {
      var _this2 = this;

      var e;
      var s = null == (e = this.viewModel) ? void 0 : e.results,
          r = this.viewModel.resultCount;
      if (r < 2) return null;
      var t = s.map(function (e) {
        return _this2.renderMoreResultsList(e);
      });
      return u("div", {
        key: "esri-search-renderer__more-results-container",
        class: n.moreResultsList
      }, t);
    }
  }, {
    key: "renderMoreResultsButton",
    value: function renderMoreResultsButton() {
      var e = this.messages,
          s = this.viewModel.resultCount;
      return s < 2 ? null : u("div", {
        key: "esri-search-renderer__more-results-button",
        class: n.moreResultsItem
      }, u("a", {
        class: n.anchor,
        href: "#",
        bind: this,
        onclick: this._showMoreResultsClick,
        onkeydown: this._showMoreResultsClick
      }, this.showMoreResultsOpen ? e.hideMoreResults : e.showMoreResults));
    }
  }, {
    key: "renderMoreResultsHeader",
    value: function renderMoreResultsHeader(e, s) {
      return u("div", {
        key: "esri-search-result-renderer__header-".concat(s),
        class: n.moreResultsListHeader
      }, e);
    }
  }, {
    key: "renderMoreResultsList",
    value: function renderMoreResultsList(e) {
      var _this3 = this;

      var s, r;

      var t = e.results,
          o = t.length,
          l = !!o,
          i = null == (s = this.viewModel) ? void 0 : s.selectedResult,
          n = 1 === o && t[0] === i,
          _c = this._getSourceName(e.source, e.sourceIndex),
          d = (null == (r = this.viewModel) ? void 0 : r.results.length) > 1 && !n ? this.renderMoreResultsHeader(_c, e.sourceIndex) : null,
          a = l && t.map(function (e, s) {
        return _this3.renderMoreResultsListItem(e, s);
      }),
          h = l && !n ? u("ul", {
        key: "esri-search-result-renderer__list-".concat(e.sourceIndex)
      }, a) : null;

      return l ? u("div", {
        key: "esri-search-result-renderer__results-".concat(e.sourceIndex)
      }, d, h) : null;
    }
  }, {
    key: "renderMoreResultsListItem",
    value: function renderMoreResultsListItem(e, s) {
      return e !== this.get("viewModel.selectedResult") ? u("li", {
        key: "esri-search-result-renderer__list-item-".concat(s)
      }, u("a", {
        class: n.anchor,
        href: "#",
        tabindex: "0",
        bind: this,
        "data-result": e,
        onclick: this._selectResultClick,
        onkeydown: this._selectResultClick
      }, e.name)) : null;
    }
  }, {
    key: "_showMoreResultsClick",
    value: function _showMoreResultsClick(e) {
      e.preventDefault(), this.showMoreResultsOpen = !this.showMoreResultsOpen;
      var s = this.get("viewModel.view.popup");
      s && s.reposition();
    }
  }, {
    key: "_selectResultClick",
    value: function _selectResultClick(e) {
      e.preventDefault();
      var s = e.currentTarget["data-result"];
      this.viewModel && this.viewModel.select(s);
    }
  }, {
    key: "_getSourceName",
    value: function _getSourceName(e, s) {
      return s === o.ALL_INDEX ? this.messages.all : e.name;
    }
  }]);

  return c;
}(t);

e([s(), i("esri/widgets/Search/t9n/Search")], c.prototype, "messages", void 0), e([s()], c.prototype, "showMoreResultsOpen", void 0), e([s()], c.prototype, "viewModel", void 0), e([l()], c.prototype, "_showMoreResultsClick", null), e([l()], c.prototype, "_selectResultClick", null), c = e([r("esri.widgets.Search.SearchResultRenderer")], c);
var d = c;
export { d as default };